<template>
  <div v-if="overlay">
    <DashboardHeader title="Switchboard">
      <v-row align="center" justify="center">
        <Loader></Loader>
        <v-card height="100%" width="100%">
          <v-row justify="center">
            <v-overlay :value="overlay">
              <div v-if="unauthorized">
                <v-alert type="error">
                  Unauthorized Access for this User to the Selected Company.
                  <br />Please Contact the Company Admin!
                </v-alert>
                <v-btn color="error" class="mb-4" @click="signOut()"
                  >Sign Out</v-btn
                >
              </div>
              <div v-else>
                <v-btn color="success" class="mb-4" @click="setUserEmis()">{{
                  overlayBarTitle
                }}</v-btn>

                <v-row>
                  <div v-if="unauthorized" class="my-6 mx-auto">OR</div>
                </v-row>
                <SwitchCompany
                  :userId="getCurrentUser.id"
                  @company-switched="companySwitched"
                ></SwitchCompany>
              </div>
            </v-overlay>
          </v-row>
        </v-card>
      </v-row>
    </DashboardHeader>
  </div>
  <div v-else>
    <!-- <DashboardHeader title="Switchboard"> -->
    <NiceAdminDashboard></NiceAdminDashboard>
    <!-- <DashboardTiles :tiles="[tiles, tilesObj]"></DashboardTiles> -->
    <!-- </DashboardHeader> -->
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import baronjs from "@/plugins/baron";
import { mapGetters } from "vuex";
import Loader from "@/components/Loader.vue";
//import DashboardTiles from "@/components/myLibrary/DashboardTiles.vue";
import SwitchCompany from "@/components/myLibrary/SwitchCompany.vue";
import DashboardHeader from "@/components/DashboardHeader.vue";
import NiceAdminDashboard from "./NiceAdminDashboard.vue";

export default {
  components: {
    //DashboardTiles,
    SwitchCompany,
    Loader,
    DashboardHeader,
    NiceAdminDashboard,
  },

  computed: mapGetters([
    "getAccessToken",
    "getUserCompany",
    "getCurrentUser",
    "getThemeColor",
    "getAppName",
    "isManager",
    "isAdmin",
    "isStaff",
    "getCompanyLabels",
    "isGuest",
    "isEverybody",
    "isEverybodyEA",
  ]),
  mounted() {
    //for docs-ai
    // if (
    //   location.hostname.includes("docs-ai.co.za") ||
    //   location.hostname.includes("172.20.10.4")
    // ) {
    //   this.$router.push({ name: "home" });
    //   return;
    // }
    //end of for docs-ai

    this.$store.commit("setLoader", true);
    axios.getData("/auth/user", this.getAccessToken).then((user) => {
      this.$store.commit("setLoader", false);
      this.$store.commit("setCurrentUser", user);
      if (user.emis == this.getUserCompany.emis) {
        this.overlayBarTitle = "Continue to " + this.getAppName;
        this.overlay = false;
        this.$store.commit("setCurrency", this.getUserCompany.currency);
        this.tilesObj = baronjs.filterTiltes(this.tiles);
      } else {
        this.overlayBarTitle = "Select Your Company";
        this.overlay = true;
      }
    });
  },
  data() {
    return {
      overlay: false,
      overlayBarTitle: null,
      unauthorized: false,
      tilesObj: [],
      tiles: [],
    };
  },
  methods: {
    setUserEmis() {
      axios
        .postDataWithToken(
          "/auth/get-selected-company",
          { emis: this.getUserCompany.emis },
          this.getAccessToken
        )
        .then((data) => {
          if (data == "unauthorized") {
            this.overlay = true;
            this.unauthorized = true;
          } else {
            this.$store.commit("setUserCompany", data.company);
            this.$store.commit("setCurrency", data.company.currency);
            this.$store.commit("setCompanyLabels", data.labels);
            this.$store.commit("setThemeColor", data.company.primary_bg_color);
            this.$store.commit(
              "setSecondaryColor",
              data.company.secondary_bg_color
            );
            this.$store.commit("setAppName", data.company.name);
            this.$store.commit("setCurrentUser", data.user);

            localStorage.setItem("themeColor", data.company.primary_bg_color);
            localStorage.setItem(
              "secondaryColor",
              data.company.secondary_bg_color
            );
            localStorage.setItem("appName", data.company.name);
            localStorage.setItem("userCompany", JSON.stringify(data.company));
            localStorage.setItem("companyLabels", JSON.stringify(data.labels));
            localStorage.setItem("currentUser", JSON.stringify(data.user));
            this.overlay = false;
          }
        });
    },
    companySwitched(company) {
      this.$store.commit("setUserCompany", company);
      localStorage.setItem("userCompany", JSON.stringify(company));
      this.overlayBarTitle = "Continue to " + company.name;
    },
    signOut() {
      axios
        .postDataWithToken("/auth/logout", {}, this.getAccessToken)
        .then(() => {
          this.$store.commit("setAuthenticated", false);
          this.$store.commit("setCurrentUser", {});
          localStorage.clear();
          this.$router.push({ path: "/" });
        });
    },
  },
};
</script>
